// extracted by mini-css-extract-plugin
export var csatScore = "_kk-5";
export var header = "_kk-1";
export var panelWrapper = "_kk-2";
export var postPreview = "_kk-3";
export var rightContent = "_kk-0";
export var wrappingText = "_kk-4";